import { render } from "./SchoolFeature.vue?vue&type=template&id=d04d552e&scoped=true"
import script from "./SchoolFeature.vue?vue&type=script&lang=js"
export * from "./SchoolFeature.vue?vue&type=script&lang=js"

import "./SchoolFeature.vue?vue&type=style&index=0&id=d04d552e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d04d552e"

export default script